export const Logo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" aria-label="Werkhaus Automotive logo">
    <rect x="2" y="2" width="40" height="40" stroke="#F8FAFC" strokeWidth="2" />
    <path d="M9 13 L16 31 L22 19 L28 31 L35 13" stroke="#F8FAFC" strokeWidth="3.5" fill="none" />
    <rect x="33" y="5" width="8" height="8" fill="#FF3815" />
  </svg>
);
